import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import CKEditor from '@ckeditor/ckeditor5-vue';

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import VueMoment from 'vue-moment'

import App from './App.vue'
import router from './router'
import store from './store'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import './assets/style.scss'

Vue.use(VueAxios, axios)
Vue.use(VueSession)
Vue.use(VueMoment);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use( CKEditor );

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  data(){
		return{
			access_key: '',
			reload_duration: 30*1000,
			
			/*APPURL: 'http://localhost:8080/',
			WEBAPI: 'http://localhost:3000/api/',
			URLPATH: 'http://localhost:3000/',
			MEDIAPATH: 'http://localhost:3000/media/',*/

			/*WEBAPI: 'http://localhost/sportswear/public/',
			URLPATH: 'http://localhost/sportswear/public/',
			MEDIAPATH: 'http://localhost/sportswear/public/media/',*/

			APPURL: 'https://gbrandusa.dyotech.pk/',
			WEBAPI: 'https://gbrandusa.dyotech.pk/api/public/api/',
			URLPATH: 'https://gbrandusa.dyotech.pk/api/public/',
			MEDIAPATH: 'https://gbrandusa.dyotech.pk/api/public/media/',
			
			ACTYPE: "MU",
			status_options: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			page_perm_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'add', text: 'Add' },{ value: 'edit', text: 'Edit' },{ value: 'delete', text: 'Delete' }],
			page_report_perm_options: [{ value: 'enabled', text: 'Enabled' },{ value: 'view', text: 'View' },{ value: 'export', text: 'Export' }]
		} 
	},
	methods: {
		is_logged_in(){
			console.log(this.$session.get('access_key'));

			if(this.$session.get('access_key') == '' || this.$session.get('access_key') == undefined){
				this.$session.destroy();
				this.$router.push('/');
				return 1;
			}else{
				return 0;
			}
		},
		chkperm(option,perm){
			var userinfo = this.$session.get('user_info');
			if(userinfo){
				if(userinfo.role == 1){
					return 1;
				}
				var options = userinfo.options;
				if(options['page_'+option]){
					if(options['page_'+option].indexOf(perm) > -1){
						return 1;
					}
				}
			}
			
			return 0;
		},
		forceLogout(msg){
			var self = this;
			this.$bvModal.msgBoxOk(msg, {
				title: 'Security Issue',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'Logout',
				okOnly: true,
				footerClass: 'p-2',
				backdrop: 'static',
				hideHeaderClose: true,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.$session.destroy();
					
					self.$router.push('/')
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		}
	}
}).$mount('#app')
